// extracted by mini-css-extract-plugin
export default {"ticketTitle":"TicketAdder_ticketTitle__j3KyH","submitBtn":"TicketAdder_submitBtn__9HkBZ"};